// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  urlService: 'https://us-central1-fitfood-22c23.cloudfunctions.net',
  urlIRPService: 'https://irp-system.web.app',
  firebase: {
    apiKey: "AIzaSyCYwDpVlBY_tJWF4uh2g2KOo3Joh9_ggxE",
    authDomain: "fitfood-22c23.firebaseapp.com",
    databaseURL: "https://fitfood-22c23.firebaseio.com",
    projectId: "fitfood-22c23",
    storageBucket: "fitfood-22c23.appspot.com",
    messagingSenderId: "2055061356"
  }

  // urlService: 'http://localhost:5000/fitfood-development/us-central1',
  // urlIRPService: 'https://irp-system.web.app',
  // firebase: {
  //   apiKey: "AIzaSyCRdHomIc7lYzBa2YX128kYeyZduZi20JM",
  //   authDomain: "fitfood-development.firebaseapp.com",
  //   databaseURL: "https://fitfood-development.firebaseio.com",
  //   projectId: "fitfood-development",
  //   storageBucket: "fitfood-development.appspot.com",
  //   messagingSenderId: "766392867039",
  //   appId: "1:766392867039:web:10edb19b29ea472704716a"
  // }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */

// import 'zone.js/dist/zone-error';



// WEBPACK FOOTER //
// ./src/environments/environment.ts